export default __webpack_public_path__ + "static/media/transfer11.23ce8385.mp4";